import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package, Ticket, Inbox, Users, HelpCircle, ArrowRight, ShoppingBag, IndianRupee } from "lucide-react";
import { adminApi } from "@/context/AdminAuthContext";
import { useSettings } from "@/context/SettingsContext";
import { Card, PageTitle } from "@/admin/ui";

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const settings = useSettings();
  useEffect(() => { adminApi.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {}); }, []);

  const tiles = stats ? [
    { label: "New orders", value: `${stats.new_orders} / ${stats.orders}`, icon: ShoppingBag, to: "/admin/orders" },
    { label: "Revenue", value: `₹${Math.round(stats.revenue || 0).toLocaleString("en-IN")}`, icon: IndianRupee, to: "/admin/orders" },
    { label: "Products", value: `${stats.active_products} live / ${stats.products}`, icon: Package, to: "/admin/products" },
    { label: "Active coupons", value: stats.coupons, icon: Ticket, to: "/admin/coupons" },
    { label: "Unread messages", value: `${stats.unread_messages} / ${stats.messages}`, icon: Inbox, to: "/admin/inbox" },
    { label: "Newsletter subscribers", value: stats.subscribers, icon: Users, to: "/admin/inbox" },
    { label: "FAQs", value: stats.faqs, icon: HelpCircle, to: "/admin/faqs" },
  ] : [];

  return (
    <div data-testid="admin-dashboard">
      <PageTitle title="Dashboard" sub="A quick look at your store." />
      <Card className={`p-5 mb-8 flex flex-wrap items-center justify-between gap-4 ${settings.coming_soon ? "border-gold/40 bg-[#FBF6E8]" : ""}`}>
        <div>
          <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-gold">Store status</p>
          <p data-testid="dashboard-store-status" className="font-serif text-xl text-forest mt-1">{settings.coming_soon ? "Coming soon banner is ON — checkout disabled" : "Store is live"}</p>
        </div>
        <Link to="/admin/settings" className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.14em] text-forest link-underline">Change <ArrowRight size={13} /></Link>
      </Card>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {tiles.map(({ label, value, icon: Icon, to }) => (
          <Link key={label} to={to} data-testid={`stat-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <Card className="p-5 hover:shadow-lg hover:shadow-forest/5 hover:-translate-y-0.5 transition-all">
              <span className="w-10 h-10 rounded-full bg-forest/5 text-forest flex items-center justify-center"><Icon size={17} /></span>
              <p className="font-serif text-2xl text-forest mt-4">{value}</p>
              <p className="text-xs text-mutedgreen mt-0.5">{label}</p>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
